import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MainRoute } from 'src/app/models/MainRoute';

@Component({
selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ErrorComponent {
  currentRoute: MainRoute;
}
